<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-8 col-lg-8">
            <h4>
              <i class="fa fa-hand-pointer-o" aria-hidden="true" style="font-size: 21px; margin-right: 10px; color: var(--iq-primary);"></i>
              {{ cvCardTitle }}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="tprepBatchAdd">{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col lg="8">
            <b-row>
              <!-- Frontend Search -->
              <!--
              <b-col sm="4" md="4" lg="4" xl="4" class="mb-3">
                <b-form-input
                  id="search"
                  v-model="filter"
                  type="search"
                  :placeholder="cvSearchText"
                ></b-form-input>
              </b-col>
              -->
              <!-- Frontend Search -->

              <!-- Backend Search -->
               <b-col class="col-12 mb-3">
                <b-form-input class="form-control"
                  @input="searchBatchWithParams"
                  v-model="search_param"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
              </b-col><!-- Backend Search -->

              <b-col class="mb-2 col-12 col-sm-4">
                <select v-model="whereFilter.batch_module" class="form-control mb-2" @change="setFilters" title="Choose custom report name">
                  <option :value="null" disabled>Choose custom report name</option>
                  <option :value="null">All</option>
                  <option v-for="(item, index) in bthFiltersList['batch_module']" :key="index" :value="item.batch_module">
                    {{ item.batch_module }}
                  </option>
                </select>
              </b-col><b-col class="mb-2 col-12 col-sm-4">
                <select v-model="whereFilter.batch_mode" class="form-control mb-2" @change="setFilters" title="Choose custom report query">
                  <option :value="null" disabled>Choose custom report query</option>
                  <option :value="null">All</option>
                  <option v-for="(item, index) in bthFiltersList['batch_mode']" :key="index" :value="item.batch_mode">
                    {{ item.batch_mode }}
                  </option>
                </select>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="mb-2 col-12 col-lg-4 date_csv">
            <div class="dateRange">
              <i class="fa-solid fa-filter-circle-xmark Download_button" title="Remove all filter" @click="removeAllFilter"></i>
              <i v-if="bthObjList && bthObjList.length > 0" :csv-title="csvTitle" class="fa-solid fa-file-csv Download_button" title="Download CSV" @click="backendCsvDownload"></i>
              <date-range-picker class="float-right" ref="picker" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"  v-model="whereFilter.dateRange"  @update="getBatchDateWise()" ></date-range-picker>
            </div>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="bthObjList && bthObjList.length > 0" :key="currentBatchNo">
            <b-table
              hover
              responsive
              :items="bthObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
            <template v-slot:cell(batch_start_date)="data">
                {{data.item.batch_start_date | dateFormatDDMMYYYY}}<br>
                <b-button class="actionIcon" @click="tprepBatchEdit(data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0 font-size-20"></i></b-button>
                <b-button class="actionIcon" @click="showBatchDeleteDialog(data.item)" ><i class="ri-delete-bin-line m-0 font-size-20"></i></b-button>
            </template>
            <template v-slot:cell(batch_link_type)="data">
              {{ getBatchLinkTypeName(data.item.batch_link_type) }}
            </template>
            <template v-slot:cell(created_on)="data">
              {{data.item.created_on | dateFormat}}
            </template>
          </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
          <b-col sm="12" md="7">
            <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
          </b-col>
          <b-col sm="5" md="5">
            <b-pagination
              v-model="currentBatchNo"
              :total-rows="totalRows"
              :per-page="dataPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
         </div>
      </b-col>
    </b-row>

    <b-modal v-model="showModelBatchAdd" scrollable :title="cvAddModalHeader">
      <tprepBatchAdd :propOpenedInModal="true" @emitCloseBatchAddModal="closeBatchAddModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeBatchAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelBatchEdit" scrollable :title="cvEditModalHeader">
      <tprepBatchEdit :propOpenedInModal="true" :propBatchObj="bthEditObj" @emitCloseBatchEditModal="closeBatchEditModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeBatchEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelBatchDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelBatchDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="tprepBatchDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { Batchs } from "../../../FackApi/api/TprepBatch.js"
import tprepBatchAdd from "./TprepBatchAdd.vue"
import tprepBatchEdit from "./TprepBatchEdit.vue"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"

export default {
  name: "TprepBatchList",
  components: {
    tprepBatchAdd,
    tprepBatchEdit
  },
  data () {
    return {
      cvCardTitle: "Tprep Batchs",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit Tprep Batchs",
      cvAddModalHeader: "Add Tprep Batchs",
      cvbtnModalCancel: "Cancel",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Batch",
      showModelBatchAdd: false,
      showModelBatchEdit: false,
      showModelBatchDelete: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "#", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Batch Start Date", key: "batch_start_date", class: "text-left align-text-top w-100", sortable: true },
        { label: "Batch Start Time", key: "batch_start_time", class: "text-left align-text-top", sortable: true },
        { label: "Batch Days", key: "batch_days", class: "text-left align-text-top", sortable: true },
        { label: "Batch Mode", key: "batch_mode", class: "text-left align-text-top", sortable: true },
        { label: "Batch Type", key: "batch_type", class: "text-left align-text-top", sortable: true },
        { label: "Batch Fees", key: "batch_fees", class: "text-left align-text-top", sortable: true },
        { label: "Batch Link", key: "batch_link", class: "text-left align-text-top", sortable: true },
        { label: "Batch Link Type", key: "batch_link_type", class: "text-left align-text-top", sortable: true },
        { label: "Batch Module", key: "batch_module", class: "text-left align-text-top", sortable: true },
        { label: "Batch Module Id", key: "batch_module_id", class: "text-left align-text-top", sortable: true },
        { label: "Created On", key: "created_on", class: "text-left align-text-top", sortable: true }
      ],
      bthObjList: [],
      bthEditObj: null,
      bthFiltersList: [],
      filter: null,
      csvTitle: "Batch",
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      delObj: null,
      whereFilter: {
        dateRange: {
          startDate: new Date(new Date().setDate(new Date().getDate() - 365)), // From Last Year
          endDate: new Date(new Date().setDate(new Date().getDate() + 1))
        },
        customReportName: "",
        customReportQuery: ""
      },
      search_param: "",
      currentBatchNo: 1,
      dataPerPage: 25,
      showLoadMoreBtn: true
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    dateFilter () {
      return { ...this.$store.getters["DateFilter/selectedDateState"] }
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    await this.getDateFilter()
    await this.tprepBatchFilterList("batch_module")
    await this.tprepBatchFilterList("batch_mode")
    this.TprepBatchList()
  },
  methods: {
    /**
     * set Filters
     */
    async setFilters () {
      this.TprepBatchList()
    },
    /**
     * Get daterange from LS. If found then use this as default else use the onse set in the data section of the object
     */
    async getDateFilter () {
      let storeDate = await this.dateFilter
      if (storeDate && storeDate.dateRange) {
        this.whereFilter = storeDate
      }
    },
    /**
     * search BatchWithParams
     */
    async searchBatchWithParams () {
      if (this.whereFilter.search_param.length <= 3) {
        return
      }
      this.currentBatchNo = 1
      this.TprepBatchList()
    },
    /**
     * load More Data
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.TprepBatchList(true)
    },
    /**
     * Calling Function as per whereFilter
     */
    async getBatchDateWise () {
      this.TprepBatchList()
      await this.setDateFilter()
    },
    /**
     * Setting Date Range in the LS
     */
    async setDateFilter () {
      let endDate = this.whereFilter.dateRange.endDate
      this.whereFilter.dateRange.endDate = new Date(new Date(endDate).setDate(new Date(endDate).getDate() + 1))
      let whereDateFilter = { dateRange: this.whereFilter.dateRange }
      await this.$store.commit("DateFilter/addSelectedDate", whereDateFilter)
    },
    /**
     * backend Csv Download
     */
    async backendCsvDownload () {
      this.TprepBatchList(false, true)
    },
    /**
     * Tprep Batch List
     */
    async TprepBatchList (loadViaLoadMore = false, downloadCsv = false) {
      try {
        // setting data for pagination
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.search_param
        this.whereFilter.downloadCsv = downloadCsv
        console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx", this.whereFilter)
        let BatchListResp = await Batchs.TprepBatchList(this, this.whereFilter)
        if (BatchListResp.resp_status) {
          if (downloadCsv) {
            window.open(BatchListResp.resp_csv_file_url)
            return
          }

          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.bthObjList = [ ...BatchListResp.resp_data.data ]
          }
          else {
            this.bthObjList = [ ...this.bthObjList, ...BatchListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true

          // Adding the serial numbers:
          this.bthObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.bthObjList.length
        }
        else {
          this.currentBatchNo = this.currentBatchNo == 1 ? 1 : (this.currentBatchNo - 1)
          this.showLoadMoreBtn = false
          this.toastMsg = BatchListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at TprepBatchList() and Exception:", err)
      }
    },
    /**
     * tprepBatchAdd
     */
    tprepBatchAdd (type) {
      try {
        this.showModelBatchAdd = true
        this.TprepBatchList()
      }
      catch (err) {
        console.error("Exception occurred at tprepBatchAdd() and Exception:", err.message)
      }
    },
    /**
     * Tprep Batch Edit
     */
    tprepBatchEdit (item) {
      try {
        this.bthEditObj = item
        this.showModelBatchEdit = true
      }
      catch (err) {
        console.error("Exception occurred at tprepBatchEdit() and Exception:", err.message)
      }
    },
    /**
     * showBatch DeleteDialog
     */
    showBatchDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelBatchDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showBatchDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * Tprep Batch Delete
     */
    async tprepBatchDelete () {
      try {
        let BatchDelResp = await Batchs.tprepBatchDelete(this, this.delObj.bth_id)
        await ApiResponse.responseMessageDisplay(this, BatchDelResp)

        if (BatchDelResp && !BatchDelResp) {
          this.showModelBatchDelete = false
          return false
        }

        let index = this.bthObjList.indexOf(this.delObj)
        this.bthObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelBatchDelete = false
      }
      catch (err) {
        console.error("Exception occurred at tprepBatchDelete() and Exception:", err.message)
      }
    },
    /**
     * closeBatch AddModal
     */
    closeBatchAddModal (BatchAddData) {
      try {
        if (BatchAddData) {
          if (this.bthObjList && this.bthObjList.length >= 1) {
            let BatchObjLength = this.bthObjList.length
            let lastId = this.bthObjList[BatchObjLength - 1]["id"]
            BatchAddData.id = lastId + 1
          }
          else {
            this.bthObjList = []
            BatchAddData.id = 11111
          }

          BatchAddData.created_on = moment()
          this.bthObjList.unshift(BatchAddData)
          this.totalRows = this.totalRows + 1
        }

        this.showModelBatchAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closeBatchAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeBatch EditModal
     */
    closeBatchEditModal () {
      try {
        this.showModelBatchEdit = false
        this.TprepBatchList()
      }
      catch (err) {
        console.error("Exception occurred at closeBatchEditModal() and Exception:", err.message)
      }
    },
    /*
     * Tprep Batch Filter List
     */
    async tprepBatchFilterList (filterName = null) {
      if (!filterName) {
        return
      }
      try {
        let BatchFilterListResp = await Batchs.tprepBatchFilterList(this, filterName)
        if (BatchFilterListResp) {
          this.bthFiltersList[filterName] = BatchFilterListResp.resp_data
        }
      }
      catch (err) {
        console.error("Exception occurred at Batch_filter_list_resp() and Exception:", err.message)
      }
    },
    /**
     * remove All Filter
     */
    removeAllFilter () {
      this.whereFilter = {
        customReportName: "",
        customReportQuery: "" // value should be null
      }
      this.TprepBatchList(false, false)
    },
    /**
     * getBatchLinkTypeName
     */
    getBatchLinkTypeName (type) {
      switch (Number(type)) {
        case 1:
          return "Modal"
        case 0:
        default:
          return "New Tab"
      }
    }
  }
}
</script>
